interface CycloneLogoProps {
  size?: number;
  className?: string;
}

export function CycloneLogo({ size = 40, className = '' }: CycloneLogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <linearGradient id="cycloneGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#3B82F6" />
          <stop offset="100%" stopColor="#60A5FA" />
        </linearGradient>
      </defs>

      <g transform="translate(50, 50)">
        <path
          d="M 0,-35 Q 15,-30 25,-15 Q 30,0 25,15 Q 15,30 0,35 Q -15,30 -25,15 Q -30,0 -25,-15 Q -15,-30 0,-35 Z"
          fill="url(#cycloneGradient)"
          opacity="0.3"
        />

        <path
          d="M 0,-28 Q 12,-24 20,-12 Q 24,0 20,12 Q 12,24 0,28 Q -12,24 -20,12 Q -24,0 -20,-12 Q -12,-24 0,-28 Z"
          fill="url(#cycloneGradient)"
          opacity="0.5"
        />

        <path
          d="M 0,-20 Q 8,-18 14,-9 Q 16,0 14,9 Q 8,18 0,20 Q -8,18 -14,9 Q -16,0 -14,-9 Q -8,-18 0,-20 Z"
          fill="url(#cycloneGradient)"
          opacity="0.7"
        />

        <circle cx="0" cy="0" r="8" fill="url(#cycloneGradient)" />

        <path
          d="M 0,-25 Q 5,-20 0,-15 M 15,-18 Q 18,-10 12,-8 M 20,0 Q 18,5 13,3 M 15,18 Q 10,18 8,12 M 0,25 Q -5,20 0,15 M -15,18 Q -18,10 -12,8 M -20,0 Q -18,-5 -13,-3 M -15,-18 Q -10,-18 -8,-12"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          opacity="0.4"
          className="text-white"
        />
      </g>
    </svg>
  );
}
